import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import assetUpdaters from '@/api/updaters/content-studio/asset';
import {CONTENT_LAB, ASSETS, FOLDERS, ASSET_FILTERS} from '../../consts';

function useMoveFolder() {
  return useMutation({
    mutationFn: ({
      folderId,
      assetIds,
    }: {
      folderId: string;
      assetIds: string[];
    }) => {
      return assetUpdaters.moveAssetsToFolder(folderId, assetIds);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [CONTENT_LAB, FOLDERS]});
      queryClient.invalidateQueries({queryKey: [CONTENT_LAB, ASSET_FILTERS]});
      queryClient.invalidateQueries({
        queryKey: [CONTENT_LAB, ASSETS],
        exact: false,
      });
    },
  });
}

export default useMoveFolder;
